import { UIEvent, useMemo, useState } from 'react';
import { BiCopy } from 'react-icons/bi';
import { useParams } from 'react-router-dom';

import { SpaceHierarchyReadModel } from '@client/api';
import { IconButton, isDefinedString } from '@client/toolkit';

import { SpaceDuplicateModal } from '../../spaces/space/components/space-duplicate-modal.component';

interface SpaceItemDuplicateButtonProps {
  item: SpaceHierarchyReadModel | undefined;
}

export function SpaceItemDuplicateButton({ item }: SpaceItemDuplicateButtonProps) {
  const { buildingId } = useParams<{ buildingId: string }>();
  const [open, setOpen] = useState(false);

  const discriminator = useMemo(() => item?.discriminator, [item?.discriminator]);

  const canDuplicate = useMemo(() => {
    if (item == null || !isDefinedString(item.id) || !isDefinedString(discriminator)) return false;
    // Building is the root — duplicating a whole building is out of scope for this feature.
    if (discriminator === 'Building') return false;
    return true;
  }, [item, discriminator]);

  const handleClick = (event: UIEvent) => {
    event.stopPropagation();
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  if (!canDuplicate) return null;

  return (
    <>
      <IconButton
        color="none"
        size="sm"
        fontSize="md"
        rounding="none"
        className="text-black hover:text-black active:bg-black/[0.10] rounded-lg"
        onClick={handleClick}
      >
        <BiCopy />
      </IconButton>
      <SpaceDuplicateModal
        open={open}
        onClose={handleClose}
        onAfterSubmit={handleClose}
        spaceId={item?.id}
        discriminator={discriminator}
        buildingId={buildingId}
      />
    </>
  );
}
